const STATUS_LABELS = {
  idle: { label: 'Hors ligne', tone: 'text-white/40', dot: 'bg-white/30' },
  connecting: {
    label: 'Connexion…',
    tone: 'text-amber-300',
    dot: 'bg-amber-300 animate-pulse',
  },
  live: {
    label: 'En direct',
    tone: 'text-live',
    dot: 'bg-live animate-pulse shadow-[0_0_10px_rgba(34,197,94,0.9)]',
  },
  reconnecting: {
    label: 'Reconnexion…',
    tone: 'text-amber-300',
    dot: 'bg-amber-300 animate-pulse',
  },
  closed: { label: 'Hors live', tone: 'text-red-300', dot: 'bg-red-400' },
};

export default function LiveStatusPill({ status, participants }) {
  const cfg = STATUS_LABELS[status] ?? STATUS_LABELS.idle;
  const showCount = status === 'live' && Number.isFinite(participants) && participants > 0;

  return (
    <div className="flex items-center gap-2 whitespace-nowrap text-[11px] font-semibold uppercase tracking-widest">
      <span className={`inline-flex h-2 w-2 shrink-0 rounded-full ${cfg.dot}`} />
      <span className={cfg.tone}>{cfg.label}</span>
      {showCount && (
        <span className="shrink-0 rounded-full bg-white/5 px-2 py-0.5 text-[10px] font-medium text-white/70 normal-case">
          {participants} en ligne
        </span>
      )}
    </div>
  );
}
